import {getAxiosTotall} from "./ApiInstance"

export const calculateDeliveryPriceApi=(info,call)=>{
    getAxiosTotall().post("delivery/calculate/", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
export const requestDeliveryApi=(info,call)=>{
    getAxiosTotall().post("delivery/call_delivery/", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
export const checkDeliverRequestApi =(callback)=>{
    getAxiosTotall().get("delivery/check_requests/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
export const userCancelDeliveryApi =(info,call)=>{
    getAxiosTotall().post("delivery/cancel/", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
export const userPayDeliveryApi =(info,call)=>{
    getAxiosTotall().post("delivery/pay/", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
export const getDeliveryRequestDataApi =(callback)=>{
    getAxiosTotall().get("delivery/requests/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}